import { takeLatest, put, call } from 'redux-saga/effects';

import { history } from '@commons';

import { createProcedimentoPecuarioCadastro, updateProcedimentoPecuarioCadastro } from '../service';
import {
    CREATE_PROCEDIMENTO_PECUARIO_CADASTRO,
    CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_PENDING,
    CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_SUCCESS,
    CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_FAILURE,
} from '@handler';

import { AlertSuccess, AlertError } from '@components/common/AlertToast'

function* sagaCreateProcedimentoPecuarioCadastro(action) {
  yield put({ type: CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_PENDING })

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createProcedimentoPecuarioCadastro, action.data);
    } else {
      yield call(updateProcedimentoPecuarioCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
    }

    yield put({ type: CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_SUCCESS, registro: action.data })

    if(!action.isCadastroRapido){
      history.push('/pecuaria/procedimentoPecuarioCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');

  } catch (error) {
    yield put({ type: CREATE_PROCEDIMENTO_PECUARIO_CADASTRO_FAILURE, registro: action.data })

    AlertError('Falha ao salvar o registro! Tente novamente...');
  }

}

export default function* watchCreateProcedimentoPecuarioCadastro() {
  yield takeLatest(CREATE_PROCEDIMENTO_PECUARIO_CADASTRO, sagaCreateProcedimentoPecuarioCadastro)
}
